import { onFormatDate } from 'components'
import * as React from 'react'

export const LocalDate: React.FC<{ graphQLDate?: string }> = ({
  graphQLDate,
}) =>
  graphQLDate ? (
    <span>{onFormatDate(new Date(Date.parse(graphQLDate)))}</span>
  ) : null
